"use client";

import { useState, useEffect } from 'react';
import { userApi } from '../../services/api';
import ArchitectureDiagram from '../visualization/ArchitectureDiagram';

export default function RepositoryDetail({ repositoryId, user }) {
  const [repository, setRepository] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (repositoryId && user?.token) {
      // Fetch repository details if needed
      console.log('Repository detail view for:', repositoryId);
      fetchRepositoryDetails();
    } else {
      // If no repositoryId, we can still show the diagram with mock data
      setLoading(false);
    }
  }, [repositoryId, user]);

  const fetchRepositoryDetails = async () => {
    setLoading(true);
    setError(null);
    
    try {
      // Assume API already provides this endpoint, add if not available
      const response = await userApi.getRepositoryById(repositoryId, user.token);
      setRepository(response.data.repository);
    } catch (err) {
      console.error("Error fetching repository details:", err);
      setError("Failed to load repository details");
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="h-full flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-[#2188FF]"></div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="h-full flex items-center justify-center">
        <div className="text-center space-y-4">
          <h3 className="text-xl font-semibold text-[#24292F] dark:text-white">Something went wrong</h3>
          <p className="text-[#57606A] dark:text-gray-400">{error}</p>
          <button
            onClick={fetchRepositoryDetails}
            className="px-4 py-2 bg-[#2188FF] hover:bg-[#0969DA] text-white rounded-lg transition-colors"
          >
            Retry
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="h-full">
      <ArchitectureDiagram repositoryId={repositoryId} user={user} repository={repository} />
    </div>
  );
} 